import { FilePreviewProps } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/Types'
import Styles from './DesignPreview.module.scss'

export const MediaFilePreview = ({ file }: FilePreviewProps) => {
  const { source_url, thumbnail_url } = file
  const src = thumbnail_url || source_url

  return <img src={src} alt="preview" className={Styles.image} />
}
